import {
  buildExamManagementNavLayout,
  buildExamManagementStudentNavLayout,
  NavLinkItem,
  NavPrimaryLayout,
} from "./navigation"
import type { UserRole } from "@/contexts/exam-role-context"

export function getExamNavLayout(role: UserRole, slug: string): NavPrimaryLayout {
  if (role === "Student") {
    return buildExamManagementStudentNavLayout(slug)
  }
  return buildExamManagementNavLayout(slug)
}

export function getExamNav(role: UserRole, slug: string): NavLinkItem[] {
  const layout = getExamNavLayout(role, slug)
  return [
    ...layout.preamble,
    ...layout.sections.flatMap(s => s.items),
    ...(layout.epilogue ?? []),
  ]
}
